// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Mobile: React.FC<{ width?: number; height?: number }> = ({ width = 11, height = 16 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 16">
            <path
                fill="currentColor"
                d="M1.5 14c0 .281.219.5.5.5h7c.281 0 .5-.219.5-.5v-3.5h-8V14Zm0-5h8V2c0-.281-.219-.5-.5-.5H2c-.281 0-.5.219-.5.5v7ZM0 2C0 .906.906 0 2 0h7c1.094 0 2 .906 2 2v12c0 1.094-.906 2-2 2H2c-1.094 0-2-.906-2-2V2Zm4.25 9.75h2.5a.76.76 0 0 1 .75.75.76.76 0 0 1-.75.75h-2.5a.76.76 0 0 1-.75-.75.76.76 0 0 1 .75-.75Z"
            />
        </svg>
    );
};

export default React.memo(Mobile);
